const styleTypes = {
  primary: 'btn-primary',
  secondary: 'btn-light-primary',
  'secondary-active': 'btn-active-light-primary',
}

const Button = ({
  loading = false,
  label,
  disabled = false,
  type = 'submit',
  className = '',
  styleType = 'primary',
  onClick,
}) => {
  return (
    <button
      type={type}
      className={`btn btn-lg ${styleTypes[styleType]} ${className}`}
      disabled={disabled}
      onClick={onClick}
    >
      {loading ? (
        <span className='indicator-progress' style={{display: 'block'}}>
          Please wait...
          <span className='spinner-border spinner-border-sm align-middle ms-2' />
        </span>
      ) : (
        <span className='indicator-label'>{label}</span>
      )}
    </button>
  )
}

export default Button
